const operationsTutorial = {
  module: 'operations',
  moduleName: 'Operations',
  steps: [
    { target: '.ops-stats-grid', position: 'bottom', title: 'Alert Summary', description: 'Active, critical, warning, and info alerts across all devices.' },
    { target: '.ops-tab-content', position: 'top', title: 'Alert Management', description: 'View, filter, acknowledge, and resolve alerts from one place.' },
  ],
};
export default operationsTutorial;
